import "moment-timezone";
import moment from "moment-timezone";
import React, { Component } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import AuthContext from "../auth-context";
import LoadingIndicator from "../Components/LoadingIndicator/LoadingIndicator";
import Flags from "../Deals/Flags";
import SRFlags from "../SeminarRegistrations/Flags";
import FormikDatetime from "../Shared/FormikDateTime";
import Pagination from "../Shared/pagination";
import TCSFlags from "../TCS/Flags";
import ConfirmationDashboardService from "../utils/ConfirmationDashboardService";

class ConfirmationDashboardList extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);

    const filter = {
      view: props.view,
      begin: moment()
        .subtract(1, "day")
        .format("DD MMM YYYY"),
      end: moment()
        .subtract(1, "day")
        .format("DD MMM YYYY")
    };

    this.state = {
      filter: filter,
      events: [],
      currentPage: 1,
      totalPages: 1,
      per: 50,
      view: props.view,
      loadingInProgress: false
    };

    this.onPageChange = this.onPageChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.params.view !== prevProps.match.params.view) {
      this.setState(
        prevState => ({
          view: this.props.view,
          filter: { ...prevState.filter, view: this.props.view }, // keep begin/end
          currentPage: 1
        }),
        this.fetchEvents
      );
    }
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, this.fetchEvents);
  }

  onPageChange(currentPage) {
    this.setState({ currentPage }, () => this.fetchEvents());
  }

  handleFilterChange(event) {
    let filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;

    this.setState({ filter, currentPage: 1 }, () => {
      this.fetchEvents();
      if (this.props.onFilterChange)
        this.props.onFilterChange(this.state.filter);
    });
  }

  dateFilterChanged(field, value) {
    let filter = { ...this.state.filter };
    filter[field] = value.format("DD MMM YYYY");

    this.setState({ filter, currentPage: 1 }, () => {
      this.fetchEvents();
      if (this.props.onFilterChange)
        this.props.onFilterChange(this.state.filter);
    });
  }

  fetchEvents() {
    this.setState({ loadingInProgress: true, events: [] });
    ConfirmationDashboardService.index({
      view: this.state.view,
      filter: this.state.filter,
      page: this.state.currentPage,
      per: this.state.per,
      begin: this.state.filter.begin,
      end: this.state.filter.end
    }).then(data => {
      let events = data.results;
      this.setState({
        loadingInProgress: false,
        events: events,
        totalCount: data.total_count,
        totalPages: Math.ceil(data.total_count / this.state.per)
      });
    });
  }

  render() {
    const List = props => {
      return (
        <tbody>
          {props.events.map(deal => (
            <ListItem key={deal.id} deal={deal} />
          ))}
        </tbody>
      );
    };

    const ListItem = props => {
      const { deal } = props;
      return (
        <tr key={props.index}>
          <td>
            <Link to={`/m1/deals/${deal.id}`} style={{ whiteSpace: "nowrap" }}>
              Deal #{deal.id}
            </Link>
          </td>
          <td>
            <Moment format="MMM D, YYYY, h:mm A">{deal.tcs_at}</Moment>
          </td>
          {this.state.view === "tcs_confirmed_not_presented" && (
            <>
              <td>
                {deal.confirmation_history
                  ? deal.confirmation_history.user_name
                  : ""}
              </td>
              <td>
                {deal.confirmation_history ? (
                  <Moment format="MMM D, YYYY, h:mm A">
                    {deal.confirmation_history.at}
                  </Moment>
                ) : (
                  "-"
                )}
              </td>
            </>
          )}
          {this.state.view === "spoke_but_not_confirmed" && (
            <>
              <td>
                <Moment format="MMM D, YYYY, h:mm A">
                  {deal.last_call_at}
                </Moment>
              </td>
            </>
          )}
          {this.state.view === "unconfirmed_with_less_than_four_calls" && (
            <>
              <td>
                <div className="d-flex">
                  <div>{deal.call_count}/4</div>
                  <div
                    style={{
                      width: "60px",
                      height: "8px",
                      backgroundColor: "#ddd",
                      borderRadius: "4px",
                      marginTop: "8px",
                      marginLeft: "8px"
                    }}
                  >
                    <div
                      style={{
                        width: `${(deal.call_count / 4) * 100}%`,
                        height: "100%",
                        backgroundColor: "#4caf50",
                        borderRadius: "4px"
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
                <Moment format="MMM D, YYYY, h:mm A">
                  {deal.last_call_at}
                </Moment>
              </td>
            </>
          )}
          <td>
            <Link to={`/m1/contacts/${deal.contact_id}`}>
              {deal.contact_email}
            </Link>
          </td>
          <td>{deal.tcs_assigned_to && <div>{deal.tcs_assigned_to}</div>}</td>
          <td>
            <SRFlags deal={deal} prefix="Registration: " />
            <TCSFlags deal={deal} prefix="TCS: " />
            <Flags deal={deal} prefix="Deal: " />
          </td>
          <td>
            {deal.lead_ids.map((lead_id, index) => (
              <Link key={lead_id} to={`/m1/follow_ups/${lead_id}`}>
                {lead_id}
                {index < deal.lead_ids.length - 1 && ", "}
              </Link>
            ))}
          </td>
          <td>
            {deal.dead_deal_reason
              ? deal.dead_deal_reason
                  .split("_")
                  .map(word => word[0].toUpperCase() + word.slice(1))
                  .join(" ")
              : ""}
          </td>
          <td>{deal.utm_source}</td>
        </tr>
      );
    };

    return (
      <div>
        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-sm-2">
            <label className="form-label small">Start</label>
            <FormikDatetime
              field="begin"
              input={{
                value: this.state.filter.begin,
                onChange: this.dateFilterChanged,
                onBlur: () => {}
              }}
              closeOnSelect={true}
              dateFormat="DD MMM YYYY"
              timeFormat={false}
            />
          </div>
          <div className="col-sm-2">
            <label className="form-label small">End</label>
            <FormikDatetime
              field="end"
              input={{
                value: this.state.filter.end,
                onChange: this.dateFilterChanged,
                onBlur: () => {}
              }}
              closeOnSelect={true}
              dateFormat="DD MMM YYYY"
              timeFormat={false}
            />
          </div>
          <div className="col-sm-3">
            {this.state.totalPages > 1 && (
              <div className="pull-right">
                <Pagination
                  currentPage={this.state.currentPage}
                  totalPages={this.state.totalPages}
                  onChange={this.onPageChange}
                />
              </div>
            )}
          </div>
        </div>
        <LoadingIndicator loading={this.state.loadingInProgress}>
          <div>
            {this.state.view === "unconfirmed_with_less_than_four_calls" && (
              <p>Shows unconfirmed bookings with fewer than 4 call attempts.</p>
            )}
          </div>
          {this.state.events.length === 0 ? (
            <div>No matches</div>
          ) : this.state.view === "unconfirmed_with_less_than_four_calls" ? (
            (() => {
              // Group events by call count
              const groupedEvents = this.state.events.reduce((groups, deal) => {
                const count = deal.call_count || 0;
                const groupKey =
                  count >= 4
                    ? "4+ Calls"
                    : `${count} Call${count === 1 ? "" : "s"}`;
                if (!groups[groupKey]) groups[groupKey] = [];
                groups[groupKey].push(deal);
                return groups;
              }, {});

              return Object.entries(groupedEvents).map(([group, deals]) => (
                <div key={group} style={{ marginBottom: "25px" }}>
                  <h5
                    style={{
                      fontWeight: "600",
                      marginTop: "20px",
                      marginBottom: "10px",
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "6px",
                      color: "#333"
                    }}
                  >
                    {group}
                  </h5>
                  <table className="table table-hover table-bordered">
                    <thead className="dark">
                      <tr>
                        <th style={{ width: 10 }}>Deal #</th>
                        <th>Appointment</th>
                        <th>Calls Made</th>
                        <th>Last Attempt At</th>
                        <th>Contact</th>
                        <th style={{ width: "90px", minWidth: "70px" }}>
                          TCS Assigned
                        </th>
                        <th>Flags</th>
                        <th>Follow Up</th>
                        <th>Dead Deal Reason</th>
                        <th>UTM</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deals.map((deal, index) => (
                        <ListItem key={index} deal={deal} index={index} />
                      ))}
                    </tbody>
                  </table>
                </div>
              ));
            })()
          ) : (
            <table className="table table-hover table-bordered">
              <thead className="dark">
                <tr>
                  <th style={{ width: 10 }}>Deal #</th>
                  <th>Appointment</th>
                  {this.state.view === "tcs_confirmed_not_presented" && (
                    <>
                      <th>Confirmation Agent</th>
                      <th>Confirmed At</th>
                    </>
                  )}
                  {this.state.view === "spoke_but_not_confirmed" && (
                    <th>Last Call At</th>
                  )}
                  <th>Contact</th>
                  <th style={{ width: "90px", minWidth: "70px" }}>
                    TCS Assigned
                  </th>
                  <th>Flags</th>
                  <th>Follow Up</th>
                  <th>Dead Deal Reason</th>
                  <th>UTM</th>
                </tr>
              </thead>
              <List events={this.state.events} />
            </table>
          )}
        </LoadingIndicator>
      </div>
    );
  }
}

export default ConfirmationDashboardList;
